import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;

  menuItems = [];
  menuItems1 = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(private eventService: EventService, private router: Router, public translate: TranslateService, private http: HttpClient) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.initialize();
    this._scrollElement();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    let menus = localStorage.getItem('menus');
    let permissions = localStorage.getItem('permissions');
    const items = this.appendMobileLabMenu(
      this.appendOrderListMenu(
        this.appendAdminBackupMenu(
          this.appendAdminOrderFilesMenu(
            this.appendAdminMailNotificationMenu(this.convertMenu(JSON.parse(menus), JSON.parse(permissions)))
          )
        )
      )
    );
    this.menuItems = this.filterTasksMenuForCustomer(items);
    this.menuItems1 = []; //MENU
  }
  mapIcon(icon: string): string {
    const iconMap: any = {
      'fa fa-dashboard': 'bx-home-circle',
      'fa fa-user-circle': 'bx-user-circle',
      'fa fa-briefcase': 'bx-briefcase',
      'fa fa-building-o': 'bx-buildings',
      'fa fa-sliders': 'bx-slider-alt',
    };

    return iconMap[icon] || 'bx-circle';
  }
  convertMenu(apiMenus: any[], apiPermission: any[]): any[] {
    apiMenus = this.filterMenusByPermission(apiMenus, apiPermission);
    return apiMenus.map(menu => this.convertMenuItem(menu));
  }
  filterMenusByPermission(apiMenus, apiPermission) {
     let role = localStorage.getItem('roleNames');
    role = JSON.parse(role)[0];
    if (!apiPermission[role]) return [];

    // Extract unique module names from permissions
    const allowedModules = [
      ...new Set(
        apiPermission[role].map(p => {
          const lastIndex = p.lastIndexOf("_");
          return p.substring(0, lastIndex);
        })
      )
    ];

    function filterMenuList(menus) {
      return menus
        .map(menu => {
          // Clone menu to avoid mutation
          const newMenu = { ...menu };

          // Recursively filter submenu if exists
          if (Array.isArray(newMenu.submenu) && newMenu.submenu.length > 0) {
            newMenu.submenu = filterMenuList(newMenu.submenu);
          }

          // Keep menu if:
          // 1. Its label is allowed
          // 2. OR it has allowed submenus
          if (
            allowedModules.includes(newMenu.label.trim()) ||
            (newMenu.submenu && newMenu.submenu.length > 0)
          ) {
            return newMenu;
          }

          return null;
        })
        .filter(Boolean);
    }

    return filterMenuList(apiMenus);
  }

  private convertMenuItem(menu: any): any {
    const converted: any = {
      id: menu.id,
      label: menu.text,
      icon: this.mapIcon(menu.icon)
    };

    // if submenu exists and has items → recurse
    if (menu.submenu && menu.submenu.length > 0) {
      converted.subItems = menu.submenu.map((child: any) =>
        this.convertMenuItem(child)
      );
    } else if (menu.link && menu.link !== '#') {
      // leaf node
      converted.link = menu.link;
    }

    return converted;
  }

  private appendAdminMailNotificationMenu(items: any[]): any[] {
    const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
    const isAdmin = (roleNames || []).some((name: string) => String(name || '').toLowerCase().includes('admin'));
    if (!isAdmin) {
      return items;
    }

    if (this.hasMenuLink(items, '/admin/mail-notifications')) {
      return items;
    }

    const adminParent = (items || []).find((item: any) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: any) => String(child?.link || '').startsWith('/admin/'))
    );

    const menuItem = {
      id: 'admin-mail-notifications',
      label: 'Mail Notification',
      icon: 'bx-envelope',
      link: '/admin/mail-notifications'
    };

    if (adminParent) {
      adminParent.subItems = [...(adminParent.subItems || []), menuItem];
      return items;
    }

    return [...(items || []), menuItem];
  }

  private appendAdminBackupMenu(items: any[]): any[] {
    const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
    const isAdmin = (roleNames || []).some((name: string) => String(name || '').toLowerCase().includes('admin'));
    if (!isAdmin) {
      return items;
    }

    if (this.hasMenuLink(items, '/admin/backups')) {
      return items;
    }

    const adminParent = (items || []).find((item: any) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: any) => String(child?.link || '').startsWith('/admin/'))
    );

    const menuItem = {
      id: 'admin-backups',
      label: 'Backups',
      icon: 'bx-data',
      link: '/admin/backups'
    };

    if (adminParent) {
      adminParent.subItems = [...(adminParent.subItems || []), menuItem];
      return items;
    }

    return [...(items || []), menuItem];
  }

  private appendAdminOrderFilesMenu(items: any[]): any[] {
    const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
    const isAdmin = (roleNames || []).some((name: string) => String(name || '').toLowerCase().includes('admin'));
    if (!isAdmin) {
      return items;
    }

    if (this.hasMenuLink(items, '/admin/order-files')) {
      return items;
    }

    const adminParent = (items || []).find((item: any) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: any) => String(child?.link || '').startsWith('/admin/'))
    );

    const menuItem = {
      id: 'admin-order-files',
      label: 'Order Files',
      icon: 'bx-file',
      link: '/admin/order-files'
    };

    if (adminParent) {
      adminParent.subItems = [...(adminParent.subItems || []), menuItem];
      return items;
    }

    return [...(items || []), menuItem];
  }

  private appendMobileLabMenu(items: any[]): any[] {
    if (!this.canAccessMobileLab()) {
      return items;
    }

    if (this.hasMenuLink(items, '/orders/mobile-lab')) {
      return items;
    }

    const ordersParent = (items || []).find((item: any) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: any) => String(child?.link || '').startsWith('/orders'))
    );

    const menuItem = {
      id: 'orders-mobile-lab',
      label: 'Mobile Lab',
      icon: 'bx-devices',
      link: '/orders/mobile-lab'
    };

    if (ordersParent) {
      ordersParent.subItems = [...(ordersParent.subItems || []), menuItem];
      return items;
    }

    return [...(items || []), menuItem];
  }

  private appendOrderListMenu(items: any[]): any[] {
    if (this.hasMenuLink(items, '/orders')) {
      return items;
    }

    const ordersParent = (items || []).find((item: any) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: any) => String(child?.link || '').startsWith('/orders'))
    );

    const menuItem = {
      id: 'orders-order-list',
      label: 'Order List',
      icon: 'bx-list-ul',
      link: '/orders'
    };

    if (ordersParent) {
      ordersParent.subItems = [menuItem, ...(ordersParent.subItems || [])];
      return items;
    }

    return [...(items || []), menuItem];
  }

  private hasMenuLink(items: any[], link: string): boolean {
    return (items || []).some((item: any) =>
      item?.link === link || this.hasMenuLink(item?.subItems || [], link)
    );
  }

  private filterTasksMenuForCustomer(items: any[]): any[] {
    if (!this.isCustomerLogin()) {
      return items;
    }

    return (items || [])
      .map((item: any) => {
        const subItems = Array.isArray(item?.subItems)
          ? this.filterTasksMenuForCustomer(item.subItems)
          : item?.subItems;

        const nextItem = subItems !== item?.subItems
          ? { ...item, subItems }
          : item;

        if (this.isTasksMenuItem(nextItem)) {
          return null;
        }

        if (Array.isArray(nextItem?.subItems) && nextItem.subItems.length === 0 && !nextItem?.link) {
          return null;
        }

        return nextItem;
      })
      .filter(Boolean);
  }

  private isTasksMenuItem(item: any): boolean {
    const label = String(item?.label || '').toLowerCase();
    const link = String(item?.link || '').toLowerCase();

    return label.includes('tasks') || link.startsWith('/tasks');
  }

  private isCustomerLogin(): boolean {
    try {
      const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
      if ((roleNames || []).some((name: string) => String(name || '').toLowerCase().includes('customer'))) {
        return true;
      }

      const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
      const roleId = Number(userData?.user?.roleId ?? userData?.roleId ?? 0);
      const departmentId = Number(userData?.user?.departmentId ?? userData?.departmentId ?? 0);
      return roleId === 2 || departmentId === 2;
    } catch {
      return false;
    }
  }

  private canAccessMobileLab(): boolean {
    try {
      const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
      const normalizedRoleNames = (Array.isArray(roleNames) ? roleNames : [])
        .map((name: string) => String(name || '').trim().toLowerCase());

      if (normalizedRoleNames.some((name: string) => name.includes('admin'))) {
        return true;
      }

      const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
      const roleId = Number(userData?.user?.roleId ?? userData?.roleId ?? 0);
      const departmentId = Number(userData?.user?.departmentId ?? userData?.departmentId ?? 0);
      if (roleId === 1 || departmentId === 1) {
        return true;
      }

      const departmentName = String(
        userData?.user?.departmentName
        ?? userData?.departmentName
        ?? userData?.department?.name
        ?? ''
      ).trim().toLowerCase();

      return normalizedRoleNames.some((name: string) =>
        name.includes('qc')
        || name.includes('back office')
        || name.includes('backoffice')
        || name.includes('mobile lab')
        || name.includes('mobilelab')
        || name.includes('vendor lab')
        || name.includes('vendorlab')
        || name.includes('vendor')
      ) || departmentName.includes('qc')
        || departmentName.includes('back office')
        || departmentName.includes('backoffice')
        || departmentName.includes('mobile lab')
        || departmentName.includes('mobilelab')
        || departmentName.includes('vendor lab')
        || departmentName.includes('vendorlab')
        || departmentName.includes('vendor');
    } catch {
      return false;
    }
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
}
